import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n/i18n";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import BlogList from "./pages/BlogList";
import BlogArticle from "./pages/BlogArticle";
import Impressum from "./pages/Impressum";
import Privacy from "./pages/Privacy";
import ConsentBanner from "./components/ConsentBanner";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <div className="App relative">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Privacy />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <ConsentBanner />
        </div>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
